
    <div class="transloco-loader-template" [innerHTML]="html"></div>
  